import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-cig-work-well-with-others',
    templateUrl: './cig-work-well-with-others.component.html',
    styleUrls: ['./cig-work-well-with-others.component.scss']
})
export class CigWorkWellWithOthersComponent implements OnInit {

    @Input() profile:Array<Object>;
    @Input() slides;
    @Input() author;
    public env;
    public profiles : any;

    public ngOnChanges( changes: SimpleChanges ) : void {

        if ( changes.profile && ! changes.profile.isFirstChange() ) {
        	this.profiles = changes.profile.currentValue;
        }
    }
    constructor() { }

    ngOnInit() {
        this.env=environment;
        this.profiles = this.profile;
    }

}
